import React from 'react';
import { ToastContainer } from 'react-toastify';

import { StoreProvider } from './_core/appContext';
import { SettingsProvider } from './context/SettingsContext';
import MainApp from './MainApp';

function App() {
   return (
      <StoreProvider>
         <SettingsProvider>
            <MainApp />
            <ToastContainer position='top-center' />
         </SettingsProvider>
      </StoreProvider>
   );
}

export default App;
